// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-invalid-input {
  display: block;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-invalid-color);
}

p {
  margin-bottom: 0;
}

.tooltip-create-password {
  display: flex;
  flex-direction: row;
}
.tooltip-create-password .tooltip-info {
  display: inline-block;
  position: relative;
  color: #2B8F14;
  text-align: left;
  width: 100%;
}
.tooltip-create-password .tooltip-info .top {
  min-width: 95%;
  max-width: 130%;
  top: -15px;
  left: 30%;
  transform: translate(-30%, -95%);
  padding: 10px 15px;
  color: #5c6166;
  background-color: #ffffff;
  font-weight: normal;
  font-size: 13px;
  border-radius: 3px;
  position: absolute;
  z-index: 99999999;
  box-sizing: border-box;
  box-shadow: 0 2px 5px 5px rgba(0, 0, 0, 0.06);
  display: none;
}
.tooltip-create-password .tooltip-info .top i {
  position: absolute;
  top: 100%;
  left: 19%;
  margin-left: -15px;
  width: 30px;
  height: 15px;
  overflow: hidden;
}
.tooltip-create-password .tooltip-info .top i::after {
  content: "";
  position: absolute;
  width: 15px;
  height: 15px;
  left: 50%;
  transform: translate(-50%, -50%) rotate(45deg);
  background-color: #ffffff;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.06);
}
@media (min-width: 1024px) and (max-width: 1199px) {
  .tooltip-create-password .tooltip-info .top i {
    left: 41.5%;
  }
}
@media (min-width: 992px) and (max-width: 1024px) {
  .tooltip-create-password .tooltip-info .top i {
    left: 41.5%;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .tooltip-create-password .tooltip-info .top i {
    left: 20.5%;
  }
}
@media (min-width: 576px) and (max-width: 767px) {
  .tooltip-create-password .tooltip-info .top i {
    left: 27.2%;
  }
}
@media (min-width: 500px) and (max-width: 575px) {
  .tooltip-create-password .tooltip-info .top i {
    left: 124px;
  }
}
@media (max-width: 375px) and (max-width: 575px) {
  .tooltip-create-password .tooltip-info .top i {
    left: 27.2%;
  }
}
@media (max-width: 375px) and (max-width: 575px) {
  .tooltip-create-password .tooltip-info .top i {
    left: 27.2%;
  }
}
.tooltip-create-password .tooltip-info.active .top {
  display: block;
}

li::marker {
  color: #B8C900;
  line-height: 10px;
  font-size: 10px;
}

.tooltip-error {
  color: #dc3545;
  font-weight: bolder;
}

.tooltip-error::after {
  content: "*";
}

.fadein {
  animation: fadein 0.2s linear forwards;
}

@keyframes fadein {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.fadeout {
  animation: fadeout 0.2s linear forwards;
}

@keyframes fadeout {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.icon-container {
  width: 10%;
}

.text-container {
  width: 88%;
}

.alert-container {
  margin-top: 30px;
}
.alert-container .alert-content-container {
  display: flex;
  width: 100%;
  margin: 0 auto;
}

.retry-container {
  padding: 1rem;
  position: relative;
  margin-top: 30px;
  background: #F2F5F7;
  margin-bottom: 1rem;
  border: 1px solid;
  border-color: #969DA4;
  border-radius: 0.25rem;
}
.retry-container .retry-content-container {
  display: flex;
  width: 100%;
  margin: 0 auto;
}
.retry-container .retry-text {
  color: #0c5460;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
